<app-header></app-header>
<div class="bg-light min-vh-100 section min-vh-100">
    <div class="container py-5">
        <div class="row">
            <div class="col-md-3">
                <app-sidebar></app-sidebar>
            </div>
            <div class="col-md-8">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>